export default __webpack_public_path__ + "static/actionButtton-a796c75d80bd82ea6bc362f8012f40d7.png";